import { render, staticRenderFns } from "./ListForm2.vue?vue&type=template&id=9d7b690a&"
import script from "./ListForm2.vue?vue&type=script&lang=js&"
export * from "./ListForm2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports